import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { CloseIcon } from "./../svg";
import { deleteLocationPoint } from "../../../redux/slices/settings";

const LocationPoints = ({ editPoint }) => {
  const { points, allCountries, rule } = useSelector((state) => ({
    points: state.settings.location.points,
    allCountries: state.settings.location.countries,
    rule: state.settings.location.rule,
  }));
  const dispatch = useDispatch();

  return (
    <>
      {!!points.length && (
        <div className="mt-4 d-flex gap-3 flex-wrap">
          {points
            .filter((point) => point.rule === rule)
            .map((item) => {
              const title =
                allCountries.find(
                  (country) => country.id === Number(item.countryId)
                )?.country || `${item.lat} ${item.long}`;
              return (
                <div
                  className="bg-primary2 text-primary rounded d-flex flex-nowrap overflow-hidden"
                  style={{ padding: "4px 12px", maxWidth: 130 }}
                  key={item.id}
                  onClick={() => editPoint(item.id)}
                >
                  <div className="me-2 text-truncate">{title}</div>
                  <div
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(deleteLocationPoint(item.id));
                    }}
                  >
                    <CloseIcon className="mb-1" />
                  </div>
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};

export default LocationPoints;
